import React from 'react';

const Error404: React.FunctionComponent = () => {
    return <h1 style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Erro 404</h1>;
};

export default Error404;
